// frontend/src/pages/TermsOfService/TermsOfService.jsx

import React, { useCallback, useState, useRef } from 'react';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import UniversalNav from '../../components/UniversalNav/UniversalNav';
import './LegalPages.css'; // Use the new shared stylesheet

const TermsOfService = () => {
    const { t } = useTranslation();
    const [isScrolled, setIsScrolled] = useState(false);
    const containerRef = useRef(null);

    const handleScroll = (e) => {
        if (e.target.scrollTop > 20) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    const particlesInit = useCallback(async (engine) => {
        await loadSlim(engine);
    }, []);

    const particlesConfig = {
        background: { color: { value: 'transparent' } },
        fpsLimit: 120,
        interactivity: { events: { onHover: { enable: true, mode: 'repulse' }, resize: true }, modes: { repulse: { distance: 100, duration: 0.4 } } },
        particles: {
            color: { value: '#ffffff' },
            links: { color: '#4fc3f7', distance: 150, enable: true, opacity: 0.4, width: 1 },
            move: { direction: 'none', enable: true, outModes: { default: 'bounce' }, random: false, speed: 1, straight: false },
            number: { density: { enable: true, area: 1000 }, value: 50 }, // Less dense
            opacity: { value: 0.5 },
            shape: { type: 'circle' },
            size: { value: { min: 1, max: 3 } },
        },
        detectRetina: true,
    };

    return (
        <div 
            ref={containerRef}
            onScroll={handleScroll}
            className={`legal-page-container ${isScrolled ? 'scrolled' : ''}`}
        >
            <Particles id="tsparticles-legal" init={particlesInit} options={particlesConfig} />
            <Helmet>
                <title>{t('termsOfServicePage.helmet.title')}</title>
                <meta name="description" content={t('termsOfServicePage.helmet.description')} />
            </Helmet>

            <div className="legal-nav-container">
                <UniversalNav />
            </div>

            <main className="legal-content-wrapper">
                <Box className="legal-glass-container">
                    <Box className="legal-header" component="header">
                        <Typography variant="h3" component="h1">
                            {t('termsOfServicePage.mainTitle')}
                        </Typography>
                        <Typography variant="subtitle1" component="p">
                            {t('termsOfServicePage.lastUpdated')}
                        </Typography>
                    </Box>

                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.agreement.title')}</Typography>
                        <Typography paragraph>
                            {t('termsOfServicePage.agreement.text')}
                        </Typography>
                    </Box>

                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.accounts.title')}</Typography>
                        <Typography paragraph>
                            {t('termsOfServicePage.accounts.text')}
                        </Typography>
                    </Box>

                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.prohibitedUses.title')}</Typography>
                        <Typography paragraph>
                            {t('termsOfServicePage.prohibitedUses.text')}
                        </Typography>
                    </Box>

                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.termination.title')}</Typography>
                        <Typography paragraph>
                            {t('termsOfServicePage.termination.text')}
                        </Typography>
                    </Box>

                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.userSubmissions.title')}</Typography>
                        <Typography paragraph>{t('termsOfServicePage.userSubmissions.text')}</Typography>
                    </Box>
                    
                    {/* NEW: Billing */}
                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.billing.title')}</Typography>
                        <Typography paragraph>{t('termsOfServicePage.billing.text')}</Typography>
                    </Box>

                    {/* NEW: API Usage */}
                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.apiUsage.title')}</Typography>
                        <Typography paragraph>{t('termsOfServicePage.apiUsage.text')}</Typography>
                    </Box>

                    {/* NEW: Immutable Ledger */}
                    <Box className="legal-section" component="section">
                        <Typography variant="h5" component="h2">{t('termsOfServicePage.immutableLedger.title')}</Typography>
                        <Typography paragraph>{t('termsOfServicePage.immutableLedger.text')}</Typography>
                   </Box>

                </Box>
            </main>
        </div>
    );
};

export default TermsOfService;